(function() {
  'use strict';

  // Simple AIOD discount display for cart page
  // This version uses the checkout page to get the actual discount
  
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getAIODDiscount() {
    // Get the current cart
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart data:', cart);
        
        // Create a checkout to see what discount AIOD applies
        fetch('/cart/prepare_checkout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => {
          // Extract checkout URL from response
          const checkoutUrl = response.url || '/checkout';
          console.log('Checkout URL:', checkoutUrl);
          
          // Fetch checkout page to see discount
          return fetch(checkoutUrl, {
            method: 'GET',
            headers: {
              'Accept': 'text/html'
            }
          });
        })
        .then(response => response.text())
        .then(html => {
          // Parse the checkout HTML to find discount
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Look for discount in various places
          let discountAmount = 0;
          let discountTitle = 'Volume Discount';
          
          // Method 1: Look for discount in the order summary
          const discountElements = doc.querySelectorAll(
            '.reduction-code__text, ' +
            '.order-summary__section--discount, ' +
            '[data-discount-amount], ' +
            '.applied-discount, ' +
            '.tags-list'
          );
          
          discountElements.forEach(el => {
            const text = el.textContent;
            console.log('Found potential discount element:', text);
            
            // Extract amount
            const amountMatch = text.match(/\$?([\d,]+\.?\d*)/);
            if (amountMatch) {
              const amount = parseFloat(amountMatch[1].replace(',', ''));
              if (amount > 0) {
                discountAmount = amount * 100; // Convert to cents
                
                // Extract title if available
                const titleMatch = text.match(/([^$\d,.-]+)/);
                if (titleMatch) {
                  discountTitle = titleMatch[1].trim();
                }
              }
            }
          });
          
          // Method 2: Look for discount in scripts
          const scripts = doc.querySelectorAll('script');
          scripts.forEach(script => {
            const content = script.textContent;
            if (content.includes('discount') && content.includes('amount')) {
              // Try to extract discount from JavaScript
              const discountMatch = content.match(/"discount_amount":\s*(\d+)/);
              if (discountMatch) {
                discountAmount = parseInt(discountMatch[1]);
              }
            }
          });
          
          // Display the discount if found
          if (discountAmount > 0) {
            displayDiscount(discountAmount, discountTitle);
          } else {
            console.log('No discount found on checkout');
            hideDiscount();
          }
        })
        .catch(error => {
          console.error('Error checking checkout discount:', error);
          
          // Fallback: Simple calculation based on quantity
          if (cart.item_count >= 48) {
            // $7 off per bottle for 48+
            const discount = cart.item_count * 700;
            displayDiscount(discount, 'Volume Discount ($7 off per bottle)');
          } else {
            hideDiscount();
          }
        });
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  function displayDiscount(amount, title) {
    const discountContainer = document.getElementById('aiod-cart-discounts');
    const discountAmountEl = document.getElementById('aiod-discount-amount');
    const discountTitleEl = document.getElementById('aiod-discount-title');
    const totalAfterDiscountEl = document.getElementById('aiod-total-after-discount');
    const discountedTotalContainer = document.querySelector('.aiod-discounted-total');
    
    if (discountContainer && discountAmountEl && amount > 0) {
      // Get current cart total
      const totalElement = document.querySelector('.totals__subtotal-value');
      let cartTotal = 0;
      
      if (totalElement) {
        const totalText = totalElement.textContent.replace(/[^0-9]/g, '');
        cartTotal = parseInt(totalText, 10);
      }
      
      // Update discount display
      discountTitleEl.textContent = title;
      discountAmountEl.textContent = '-' + formatMoney(amount, window.theme?.moneyFormat || '${{amount}}');
      
      // Calculate and display new total
      if (totalAfterDiscountEl && cartTotal) {
        const newTotal = cartTotal - amount;
        totalAfterDiscountEl.textContent = formatMoney(newTotal, window.theme?.moneyFormat || '${{amount}}');
        if (discountedTotalContainer) {
          discountedTotalContainer.style.display = 'block';
        }
      }
      
      // Show the discount container
      discountContainer.style.display = 'block';
    }
  }

  function hideDiscount() {
    const discountContainer = document.getElementById('aiod-cart-discounts');
    if (discountContainer) {
      discountContainer.style.display = 'none';
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function() {
    // Check for discount on page load
    setTimeout(getAIODDiscount, 1000);
    
    // Re-check when cart is updated
    document.addEventListener('cart:updated', function() {
      setTimeout(getAIODDiscount, 1000);
    });
  });
})();